export const env = {
  production: false,
  show_threat_map: true,
  url_base: 'https://bll-analytics-data.mss.mrsp.io'
};